var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxEditFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2119 8.89844L6.40039 17.7119C6.2129 17.8994 5.95848 18.0048 5.69336 18.0049H2.5C2.22397 18.0049 2.00019 17.7809 2 17.5049V14.3105C2.00007 14.0454 2.10552 13.791 2.29297 13.6035L11.1045 4.79102L15.2119 8.89844ZM13.2568 2.62891C13.8426 2.04309 14.7932 2.04309 15.3789 2.62891L17.3623 4.6123C17.9481 5.19812 17.9481 6.14856 17.3623 6.73438L16.167 7.92969L12.0625 3.82422L13.2568 2.62891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxEditFilled);
export default __webpack_public_path__ + "static/media/icon_20px_edit_filled.bc065460bacac3dab8032fc300b3e9ba.svg";
export { ForwardRef as ReactComponent };